import React, { Component, useState } from "react";
import "./ProfilePage.css";
import { useEffect } from "react";
import { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import url from "../../Utility/URL/url";
import defaultProfilePic from "../../Utility/images/profilepic.jpg";
import Loader from "../../Utility/loader/Loader";
import { getPriceUtility } from "../../Utility/Price/getPriceUtility";
import { toast } from "react-toastify";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import FeedbackBanner from "../../Utility/images/feedback2.gif";
import videoIcon from "../../Utility/images/icons/videoCall.svg";
import chatIcon from "../../Utility/images/icons/chat.svg";
import customLinkIcon from "../../Utility/images/icons/customLink.svg";
import facebookIcon from "../../Utility/images/icons/facebook.svg";
import instagramIcon from "../../Utility/images/icons/instagram.svg";
import linkedinIcon from "../../Utility/images/icons/linkedin.svg";
import twitterIcon from "../../Utility/images/icons/twitterIcon.svg";
import youtubeIcon from "../../Utility/images/icons/youtube.svg";

const ProfilePage = () => {
  //First getting the username from the url by using the useParam;
  const { username } = useParams();
  const [loading, setLoading] = useState(true);

  //advisorInformation after apicall
  const [advisorInformation, setAdvisorInformation] = useState(null);

  //Be the first to leave a review!
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [name, setName] = useState("");
  const [text, setText] = useState("");

  const stars = [1, 2, 3, 4, 5];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedRating === 0) {
      alert("Please select a rating");
      return;
    }

    console.log("Review submitted:", {
      name,
      rating: selectedRating,
      text,
    });

    alert("Thank you for your review! It will be published after moderation.");

    // reset
    setName("");
    setText("");
    setSelectedRating(0);
    setHoverRating(0);
    setIsOpen(false);
  };

  const getDomain = (url) => {
  if (!url) return "";
  // Remove <p> tags and trim spaces
  let cleanUrl = url.replace(/<\/?p>/g, "").trim();

  // Remove http(s)://
  cleanUrl = cleanUrl.replace(/^https?:\/\//, "");

  // Optional: remove "www."
  cleanUrl = cleanUrl.replace(/^www\./, "");

  return cleanUrl;
};
  const profileContainerRef = useRef(null);
  const profileSectionRef = useRef(null);
  const demoSectionsRef = useRef([]);
  const tickingRef = useRef(false);

  // Scroll shrink effect
  const updateHeader = () => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    const maxScroll = 10;
    const progress = Math.min(scrollPosition / maxScroll, 1);
    const easeProgress = 1 - Math.pow(1 - progress, 3);

    if (easeProgress > 0.1) {
      profileContainerRef.current?.classList.add("shrunk");
      profileSectionRef.current?.classList.add("shrunk");
    } else {
      profileContainerRef.current?.classList.remove("shrunk");
      profileSectionRef.current?.classList.remove("shrunk");
    }

    tickingRef.current = false;
  };

  const requestTick = () => {
    if (!tickingRef.current) {
      requestAnimationFrame(updateHeader);
      tickingRef.current = true;
    }
  };

  useEffect(() => {
    // Scroll listener
    window.addEventListener("scroll", requestTick, { passive: true });

    // IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    demoSectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", requestTick);
      observer.disconnect();
    };
  }, []);

  // Hardware acceleration hack
  useEffect(() => {
    const selectors = [
      ".profile-container",
      ".profile-image",
      ".service-card",
      ".social-links",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.style.willChange = "transform";
        el.style.transform = "translateZ(0)";
      });
    });
  }, []);

  //whenever inside the array of useEffect Value changes then useEffect runs.
  //Empty array means onMount like componentOnMount function in class.
  useEffect(() => {
    getData();
  }, []);

  // const [isShrunk, setIsShrunk] = useState(false);

  // useEffect(() => {
  //   const profile = profileContainerRef.current;

  //   const handleScroll = () => {
  //     if (window.scrollY > 100) {
  //       setIsShrunk(true);
  //     } else {
  //       setIsShrunk(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const [selectedType, setSelectedType] = useState("All");

  const [selectedReview, setSelectedReview] = useState(null);

  const handleCardClick = (review) => {
    setSelectedReview(review);
  };

  const handleClosePopup = () => {
    setSelectedReview(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("popup-overlay")) {
      handleClosePopup();
    }
  };

  useEffect(() => {
    if (selectedReview) {
      // Lock scroll
      document.body.style.overflow = "hidden";
    } else {
      // Unlock scroll
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedReview]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.8,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 1,
    },
  };

  function returnProfilePicString() {
    //if the image comes with the profileData then return the image.
    //also check wether it's a image name or the url the backend can contain anything .
    //if its a url then show the return the url else show the image name with.png

    //if it's not available then return the default pic.

    if (advisorInformation) {
      if (advisorInformation.profileData.profilePic) {
        const url = advisorInformation.profileData.profilePic;

        if (isValidUrl(url)) {
          return url;
        } else {
          try {
            const image = require(`../../Utility/images/${url}`);
            return image;
          } catch (error) {
            return defaultProfilePic;
          }
        }
      } else {
        return defaultProfilePic;
      }
    }
  }

  const isValidUrl = (urlString) => {
    try {
      return Boolean(new URL(urlString));
    } catch (e) {
      return false;
    }
  };

  async function getData() {
    try {
      const response = await axios.get(
        url.GET_USER_PROFILE_INFORMATION + username
      );
      setAdvisorInformation(response.data);
      setLoading(false);
    } catch (error) {
      toast.error("User not Found..");
    }
  }

  const getServicesOffered = () => {
    const { servicesOffered } = advisorInformation ? advisorInformation : [];

    const activeServices = servicesOffered
  ? servicesOffered
      .filter((service) => !service.hideInProfileFlag)
      .sort((a, b) => {
        const getPriority = (p) => {
          if (!p) return 9999;  
          const [main, sub] = p.split("_").map(Number);
          return main * 100 + (sub || 0);
        };
        return getPriority(a.displayPriority) - getPriority(b.displayPriority);
      })
  : [];


    // Get unique types dynamically from the data and add "All"
    const types = ["All", ...new Set(activeServices.map((item) => item.type))];

    const filteredData =
      selectedType === "All"
        ? activeServices
        : activeServices.filter((item) => item.type === selectedType);

    return (
      <div className="reach-out-to-me">
        <div className="container">
          {activeServices.length > 0 ? (
            <div className="container">
              <div className="reaching-heading">
                <h1>Reach out to me</h1>
              </div>
              <div className="reaching-methods">
                <div className="row">
                  <div className="categoryContainer nav-tabs">
                    {types.map((category) => (
                      <button
                        key={category}
                        onClick={() => setSelectedType(category)}
                        className={`serviceCategoryButton ${
                          selectedType === category
                            ? category === "All"
                              ? "active-blue"
                              : category === "ONE_ON_ONE_CALL"
                              ? "active-red"
                              : "active-green"
                            : ""
                        }`}
                      >
                        {category === "ONE_ON_ONE_CALL" && "1:1 Video Call"}
                        {category !== "ONE_ON_ONE_CALL" &&
                          category
                            .replace(/_/g, " ")
                            .toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </button>
                    ))}
                  </div>
                  {filteredData.map((service, index) => {
                    return !service.hideInProfileFlag ? (
                      <div className="col-lg-6 my-lg-3 my-2" key={index}>
                        <div className="card service-card bsnone">
                          <div className="card-body" style={{ width: "100%" }}>
                            <div className="card-title">
                              <div className="row">
                                <div className="col-lg-2 col-2">
                                  <div className="video-icon">
                                    {service?.type === "TEXT_QUERY" && (
                                      <img src={chatIcon} className="" />
                                    )}
                                    {service?.type === "ONE_ON_ONE_CALL" && (
                                      <img src={videoIcon} className="" />
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-10 col-10">
                                  <div className="service-title fs-4 text-left">
                                    {service.title}
                                  </div>
                                  {/* <p className="card-text pt-2 text-left">
                                    {service.type === "ONE_ON_ONE_CALL"
                                      ? "1:1 Video Meet"
                                      : service.type === "TEXT_QUERY" ? "Text Query" : service.type}
                                  </p> */}
                                  <p className="card-text pt-2 text-left">
                                    {service?.shortDescription}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="card-footer-section">
                              <div className="donation-container text-center d-lg-flex justify-content-between">
                                <div className="mt-3 d-flex justify-content-between align-items-center ">
                                  <div className="bg-green-time text-center p-2 ">
                                    <i className="fa-solid fa-stopwatch text-black pr-2"></i>
                                    {service.type !== "TEXT_QUERY" && (
                                      <>{service.callDuration} min</>
                                    )}
                                    {service.type === "TEXT_QUERY" && (
                                      <>Answer in 2 days</>
                                    )}
                                  </div>
                                  <div className="bg-yellow-ruppes text-center p-2 ml-2">
                                    <i className="fa-solid fa-money-bill text-black pr-2"></i>
                                    {getPriceUtility(
                                      advisorInformation.profileData.currency,
                                      service.price
                                    )}
                                  </div>
                                </div>
                                <div className="btn btn-primary py-2 px-3 mt-3">
                                  <Link
                                    to={
                                      service.type === "TEXT_QUERY"
                                        ? `/${service.username}/${service.platformServiceId}/priority/dm`
                                        : `/${service.username}/${service.platformServiceId}`
                                    }
                                    state={{
                                      from: "profilePage",
                                      advisorInfo: advisorInformation,
                                      serviceInformation: service,
                                    }}
                                  >
                                    Book Now
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
              </div>{" "}
            </div>
          ) : (
            <div className="container">
              <div className="h1">
                Hey! Just created my profile on AdvisingBuddy.com stay tuned for
                more update
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const StarRating = ({ totalStars = 5, rating = 0 }) => {
    const renderStars = () => {
      return Array.from({ length: totalStars }, (_, index) => {
        const starIndex = index + 1;
        const isFilled = starIndex <= rating;

        return (
          <svg
            key={index}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isFilled ? "#FFD700" : "#D3D3D3"}
            style={{ width: "15px", height: "15px" }}
          >
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        );
      });
    };

    return <div className="d-flex">{renderStars()}</div>;
  };

  getServicesOffered();
  function getPublicProfilePage() {
    // console.log(advisorInformation.);

    // window.onscroll = function () { scrollFunction() };

    // function scrollFunction() {
    //   if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    //     document.getElementById("public-profile-image").style.width = "200px";
    //     document.getElementById("public-profile-image").style.height = "200px";
    //     document.getElementById("public-profile-section").style.height = "90px";
    //     document.getElementById("public-profile-section").style.position = "sticky";
    //     document.getElementById("public-profile-section").style.top = "79px";
    //     document.getElementById("profile-name").style.display = "block";
    //   } else {
    //     document.getElementById("public-profile-image").style.width = "300px";
    //     document.getElementById("public-profile-image").style.height = "300px";
    //     document.getElementById("public-profile-section").style.height = "150px";
    //     document.getElementById("public-profile-section").style.position = "relative";
    //     document.getElementById("public-profile-section").style.top = "0";
    //     document.getElementById("profile-name").style.display = "none";

    //   }
    // }

    return (
      <div className="public-profilePage">
        <div className="header-block">
          <div className="header-wrapper flex justify-content-between border-bottom-1">
            <a variant="base" className="header-logo" href="/">
              <div className="logo-wrapper" data-testid="logo" width="auto">
                Advising Buddy
              </div>
            </a>
          </div>
        </div>
        <main>
          <div className="public-profile-main">
            <div
              ref={profileContainerRef}
              className={`profile-container ${
                advisorInformation ? "" : "shrunk"
              }`}
              id="profileContainer"
            >
              <div
                className="profile-section"
                ref={profileSectionRef}
                id="profileSection"
              >
                {/* Profile Image */}
                <div className="profile-image">
                  <img
                    src={returnProfilePicString()}
                    alt="Profile"
                    className="sl-profile-avatar rounded-circle p-lg-4 p-3"
                  />
                </div>

                {/* Profile Info */}
                <div className="d-flex gap-4">
                  <div className="profile-info">
                    <h1 className="profile-name">
                      {advisorInformation?.profileData?.fullName || ""}
                    </h1>
                    <div className="profile-description">
                      <ReadMoreLess
                        text={advisorInformation?.profileData?.description}
                      />
                    </div>
                   <div className="company">
   {advisorInformation?.profileData?.workDescriptionShort || ""}
  <img
  src={`https://logo.clearbit.com/${getDomain(advisorInformation?.profileData?.companyLogo)}`}
  alt={`${advisorInformation?.profileData?.companyLogo} logo`}
  height="18"
  style={{ borderRadius: "3px", marginLeft: "6px", maxWidth: "1.6rem" , width:'100%'}}
/>




                    </div>
                     {/* <div className="company">
    {advisorInformation?.profileData?.company || "www.google.com"}
  </div> */}
                      <div className="details" style={{display:"flex", alignItems:"center", gap:"3px"}}>
  {/* Company name if needed */}
  {/* <div className="company-name">
    www.google.com
  </div> */}
 

  
    

  <div>
    {advisorInformation?.profileData?.state || "Delhi,"}
  </div>,
  <div>
    {advisorInformation?.profileData?.country || "India"}
  </div>
   <img
    src={`https://flagcdn.com/${(advisorInformation?.profileData?.countryCode || "in").toLowerCase()}.svg`}
    alt={`${advisorInformation?.profileData?.country || "India"} flag`}
    width="24"
    height="18" style={{borderRadius:"3px", marginRight:"3px"}}
  />

</div>

                  </div>
                  <div className="social-links">
                    {advisorInformation?.profileData?.linkedinLink && (
                      <a
                        href={advisorInformation.profileData.linkedinLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={linkedinIcon} alt="LinkedIn" />
                      </a>
                    )}
                    {advisorInformation?.profileData?.twitterLink && (
                      <a
                        href={advisorInformation.profileData.twitterLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={twitterIcon} alt="Twitter" />
                      </a>
                    )}
                    {advisorInformation?.profileData?.youtubeLink && (
                      <a
                        href={advisorInformation.profileData.youtubeLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={youtubeIcon} alt="YouTube" />
                      </a>
                    )}
                    {advisorInformation?.profileData?.customLink && (
                      <a
                        href={advisorInformation.profileData.customLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={customLinkIcon} alt="Custom Link" />
                      </a>
                    )}
                    {advisorInformation?.profileData?.instagramLink && (
                      <a
                        href={advisorInformation.profileData.instagramLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={instagramIcon} alt="Instagram" />
                      </a>
                    )}
                    {advisorInformation?.profileData?.facebookLink && (
                      <a
                        href={advisorInformation.profileData.facebookLink}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img src={facebookIcon} alt="Facebook" />
                      </a>
                    )}
                  </div>
                </div>
                {/* Social Links */}
              </div>
            </div>

           
            {/* services offered by advisor */}
            <section
              // style={{
              //   marginTop: isShrunk ? "150px" : "0", transition: "margin-top 0.3s ease"
              // }}
            >
              {getServicesOffered()}
            </section>

            {/* feedback section  */}
            <section>
              {advisorInformation ? (
                advisorInformation.userReviews.length === 0 ? (
                  <div>
                    <div
                      class="feedback-section"
                      style={{
                        width: "100%",
                         maxWidth: "1200px",
                        borderRadius: "8px",
                        padding: "40px",
                        marginTop: "10px",
                        margin:"3.5rem auto"
                      }}
                    >
                      <h1 class="feedback-heading">Feedback</h1>

                      <div class="empty-state">
                        <div class="empty-state-icon">
                          <svg fill="currentColor" viewBox="0 0 24 24">
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                              style={{ color: "white" }}
                            />
                          </svg>
                        </div>

                        <div class="stars">
                          {stars.map((s) => (
                            <svg
                              key={s}
                              className="star"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 
              9.27l-5 4.87 1.18 6.88L12 
              17.77l-6.18 3.25L7 14.14 2 
              9.27l6.91-1.01L12 2z" style={{color:"gold"}}
                              />
                            </svg>
                          ))}
                        </div>

                        <h3>Be the first to leave a review!</h3>
                        <p>
                          Help others discover this amazing mentor by sharing
                          your experience and insights.
                        </p>

                        <button class="review-button" onClick={() => setIsOpen(true)}>
                          Write a Review
                        </button>
                      </div>
                    </div>
                    {/* Review Modal  */}
                     {isOpen && (
                    <div class="modal active" onClick={(e) => e.target === e.currentTarget && setIsOpen(false)} id="reviewModal">
                      <div class="modal-content">
                        <button class="close-button" onClick={() => setIsOpen(false)}>
                          &times;
                        </button>
                        <h2>Write a Review</h2>

                        <form onSubmit={handleSubmit}>
                          <div class="form-group">
                            <label>Your Name</label>
                            <input
                              type="text"
                              id="reviewerName"
                              required
                              placeholder="Enter your name"
                              onChange={(e) => setName(e.target.value)}
                            />
                          </div>

                          <div class="form-group">
                            <label>Rating</label>
                            <div class="rating-container" onMouseLeave={() => setHoverRating(0)} id="ratingContainer">
                               {stars.map((star) => (
                    <svg
                      key={star}
                      className={`rating-star ${
                        (hoverRating || selectedRating) >= star ? "active" : ""
                      }`}
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      onClick={() => setSelectedRating(star)}
                      onMouseOver={() => setHoverRating(star)}
                    >
                      <path d="M12 2l3.09 6.26L22 
                      9.27l-5 4.87 1.18 6.88L12 
                      17.77l-6.18 3.25L7 14.14 2 
                      9.27l6.91-1.01L12 2z" />
                    </svg>
                  ))}
                              
                            </div>
                          </div>

                          <div class="form-group">
                            <label>Your Review</label>
                            <textarea
                              id="reviewText"
                              required
                              placeholder="Share your experience with this mentor..."
                              onChange={(e) => setText(e.target.value)}

                            ></textarea>
                          </div>

                          <button type="submit" class="submit-button">
                            Submit Review
                          </button>
                        </form>
                      </div>
                    </div>
                          )}
                  </div>
                ) : (
                  <div className="feedback-section">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-3 d-flex flex-column align-items-center">
                          <div className="feedback-heading-image">
                            <div className="feedback-heading">
                              <h1>Feedback</h1>
                            </div>
                          </div>
                          <div className="feedback-image">
                            <img
                              src={FeedbackBanner}
                              alt="not-found"
                              className="actual-feedback-image"
                            />
                          </div>
                        </div>

                        <div
                          className={`col-lg-9 ${
                            selectedReview ? "blurred" : ""
                          }`}
                        >
                          <div className="feedback-container">
                            <div className="row">
                              {advisorInformation && (
                                <Carousel
                                  responsive={responsive}
                                  infinite={true}
                                  partialVisible={true}
                                  autoPlay={!selectedReview}
                                  autoPlaySpeed={2000}
                                  keyBoardControl={true}
                                  customTransition="all 0.5s ease"
                                  containerClass="carousel-container"
                                  itemClass="carousel-item-spacing"
                                  arrows={false}
                                >
                                  {advisorInformation.userReviews.map(
                                    (review, index) => (
                                      <div
                                        key={index}
                                        className="feedback-card-container"
                                        onClick={() => handleCardClick(review)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="card feedback-card shadow-none border rounded">
                                          <div
                                            className="card-body "
                                            style={{
                                              width: "100%",
                                              textAlign: "center",
                                              position: "relative",
                                              padding: "20px 26px",
                                            }}
                                          >
                                            <div className="card-title mb-1 p-0 ">
                                              <div className="feedback-title feedback-name-of-person">
                                                <div className="d-flex">
                                                  <div className="col-lg-3 col-3 px-0">
                                                    <div className="feedback-profile-img">
                                                      <img
                                                        src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png"
                                                        alt="User"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-10 text-left px-2 py-1 pb-2">
                                                    <h5 className="mb-1 ">
                                                      {review.name}
                                                    </h5>
                                                    <div className="items-center justify-center bg-gray-100">
                                                      <StarRating
                                                        totalStars={5}
                                                        rating={Math.round(
                                                          review.rating
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <p className="card-text mb-0 pt-1 fs-10 text-left">
                                              {review.description.split(" ")
                                                .length > 12
                                                ? review.description
                                                    .split(" ")
                                                    .slice(0, 12)
                                                    .join(" ") + "..."
                                                : review.description}
                                            </p>

                                            {review.description.split(" ")
                                              .length > 12 && (
                                              <button
                                                className="btn btn-link px-2 mt-0 float-left"
                                                style={{
                                                  fontSize: "0.9rem",
                                                  color: "#007bff",
                                                  fontWeight: "bold",
                                                  textDecoration: "none",
                                                  minHeight: "20px",
                                                  position: "absolute",
                                                  bottom: "0",
                                                  right: "0",
                                                  // width:"100%",
                                                  // textAlign:"end"
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleCardClick(review);
                                                }}
                                              >
                                                Read full review →
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </Carousel>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* === Popup Modal === */}
                    {selectedReview && (
                      <div
                        className="popup-overlay"
                        onClick={handleOverlayClick}
                      >
                        <div className="popup-card">
                          <button
                            className="popup-close"
                            onClick={handleClosePopup}
                          >
                            &times;
                          </button>
                          <div className="popup-content text-left">
                            <div className="d-flex feedback-profile-img">
                              <img
                                src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png"
                                alt="User"
                              />
                              <div className="ml-2">
                                <h4 className="mb-0 mt-1">
                                  {selectedReview.name}
                                </h4>
                                <StarRating
                                  totalStars={5}
                                  rating={Math.round(selectedReview.rating)}
                                />
                              </div>
                            </div>

                            <p className="pt-3">{selectedReview.description}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              ) : (
                ""
              )}
            </section>
          </div>
        </main>
      </div>
    );
  }

  const ReadMoreLess = ({ text, maxLength = 300 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleReadMore = () => setIsExpanded(!isExpanded);

    const isTextLong = text.length > maxLength;

    return (
      <div className="user-experience fs-5 d-flex flex-lg-row flex-column align-items-end">
        <span
          dangerouslySetInnerHTML={{
            __html: `${
              text
                ? isExpanded || !isTextLong
                  ? text
                  : `${text.slice(0, maxLength)}...`
                : ""
            }`,
          }}
        ></span>
        {isTextLong && (
          <>
            {!isExpanded && <span></span>}
            <span onClick={toggleReadMore} className="see-more-less-button">
              {isExpanded ? " see less" : " see more"}
            </span>
          </>
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      {/* {advisorInformation ? getPublicProfilePage() : <loader />} */}
      {/* {loading ? <loader /> : getPublicProfilePage()} */}
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Loader />
        </div>
      )}
      {advisorInformation && <div>{getPublicProfilePage()}</div>}
    </React.Fragment>
  );
};

export default ProfilePage;
